// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bbb_a"};